import { Provider } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function httpLoaderFactory(http: HttpClient, config: ConfigurationService) {
  const staticSpaUrl = config.getValueOrBlank('oel-static-spa-url');
  return new TranslateHttpLoader(http, `${staticSpaUrl}/assets/i18n/`, '.json');
}

export const TRANSLATE_HTTP_LOADER_PROVIDER: Provider = {
  provide: TranslateLoader,
  useFactory: httpLoaderFactory,
  deps: [HttpClient, ConfigurationService],
};
